import React from "react";

const CoursesByLeaders = () => {
  return (
    <section className="py-12 md:py-16 lg:py-24 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="container mx-auto px-16">
        <div className="flex flex-col lg:flex-row gap-12 items-center">
          {/* Image Section */}
          <div className="w-full lg:w-1/2">
            <img 
              src="/home-4/dreamJob/2.png" 
              alt="Industry leaders teaching courses" 
              className="w-full h-auto rounded-lg"
            />
          </div>

          {/* Content Section */}
          <div className="w-full lg:w-1/2">
            <h3 className="text-2xl md:text-title font-bold text-dark-1 dark:text-white leading-tight mb-6">
             Apprends avec les meilleurs, 
              <br className="hidden lg:block" /> 
             où que tu sois
            </h3>
            
            <p className="text-gray-600 dark:text-gray-300 text-normal mb-8">
              Nos tuteurs viennent de MIT, Stanford, Sorbonne, Polytechnique, Maker’s Asylum, etc.
            </p>
            
            <div className="flex flex-wrap gap-4 mt-8">
              <button className="px-[55px] py-5 bg-red-4 text-button hover:bg-white text-white font-medium rounded-full
              transition-colors duration-300 hover:text-red-4 border-2 border-red-4">
                Rencontre nos tuteurs
              </button>
              
              <button className="px-[55px] py-5 border-2 text-button border-blue-1 text-blue-1 hover:bg-blue-1 font-medium rounded-full
              transition-colors duration-300 hover:text-white">
                Réserve une session
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoursesByLeaders;